/**
 * API для работы с DeepSeek
 */

const DEEPSEEK_API_URL = 'https://api.deepseek.com/v1/chat/completions';

// Функция для анализа диаграммы через DeepSeek API
export const analyzeWithDeepSeek = async (diagramCode, elements = []) => {
  try {
    const apiKey = process.env.REACT_APP_DEEPSEEK_API_KEY;

    // Отладочная информация
    console.log('DeepSeek API Key status:', {
      exists: !!apiKey,
      length: apiKey?.length,
      firstChars: apiKey?.substring(0, 8) + '...',
      isDefault: apiKey === 'your_deepseek_api_key_here'
    });

    if (!apiKey || apiKey === 'your_deepseek_api_key_here') {
      console.error('API ключ не найден в переменных окружения:', process.env);
      throw new Error('API ключ DeepSeek не настроен. Проверьте файл .env и перезапустите сервер');
    }

    // Подготавливаем описание диаграммы
    const elementsSummary = elements.map(el => {
      if (el.type === 'rectangle') {
        return `Rectangle: ${el.width}x${el.height} at (${Math.round(el.x)}, ${Math.round(el.y)})`;
      } else if (el.type === 'circle') {
        return `Circle: radius ${el.radius} at (${Math.round(el.x)}, ${Math.round(el.y)})`;
      } else if (el.type === 'arrow') {
        return `Arrow: from (${Math.round(el.x)}, ${Math.round(el.y)}) to (${Math.round(el.x2)}, ${Math.round(el.y2)})`;
      } else if (el.type === 'text') {
        return `Text: "${el.content}" at (${Math.round(el.x)}, ${Math.round(el.y)})`;
      }
      return `${el.type} element`;
    }).join('\n');

    const prompt = `Проанализируй следующую диаграмму и дай краткий анализ (не более 200 слов):

Код диаграммы:
${diagramCode}

Сгенерированные элементы:
${elementsSummary}

Пожалуйста, дай анализ с точки зрения:
1. Что представляет данная диаграмма
2. Основные взаимодействия
3. Возможные улучшения или рекомендации

Отвечай на русском языке.`;

    const response = await fetch(DEEPSEEK_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiKey}`,
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        model: 'deepseek-chat',
        messages: [
          {
            role: 'system',
            content: 'Ты эксперт по анализу диаграмм и архитектуре программного обеспечения. Давай краткие и полезные анализы диаграмм.'
          },
          {
            role: 'user',
            content: prompt
          }
        ],
        max_tokens: 300,
        temperature: 0.7
      })
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('DeepSeek API Error:', response.status, errorText);

      if (response.status === 401) {
        throw new Error('Неверный API ключ DeepSeek. Проверьте настройки в файле .env');
      }
      throw new Error(`Ошибка API DeepSeek: ${response.status} - ${errorText}`);
    }

    const data = await response.json();
    return {
      success: true,
      analysis: data.choices[0]?.message?.content || 'Анализ не получен',
      timestamp: new Date().toISOString()
    };

  } catch (error) {
    console.error('Ошибка при анализе с DeepSeek:', error);
    return {
      success: false,
      error: error.message,
      timestamp: new Date().toISOString()
    };
  }
};

// Функция для получения краткого анализа диаграммы
export const getQuickAnalysis = async (diagramCode) => {
  try {
    const prompt = `Дай очень краткий анализ (1-2 предложения) этой диаграммы:

${diagramCode}

Определи тип диаграммы и её основное назначение.`;

    const response = await fetch(DEEPSEEK_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${process.env.REACT_APP_DEEPSEEK_API_KEY}`,
      },
      body: JSON.stringify({
        model: 'deepseek-chat',
        messages: [
          {
            role: 'system',
            content: 'Ты эксперт по диаграммам. Давай очень краткие ответы.'
          },
          {
            role: 'user',
            content: prompt
          }
        ],
        max_tokens: 100,
        temperature: 0.5
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return {
      success: true,
      analysis: data.choices[0]?.message?.content || 'Анализ не получен'
    };

  } catch (error) {
    console.error('Ошибка при быстром анализе:', error);
    return {
      success: false,
      error: error.message
    };
  }
};
